// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirm-note[data-v-7c82c9c6] {\n  background-color: #fff3e0;\n  border: 1px solid #ffb74d;\n  border-left: 4px solid #e65100;\n  border-radius: 4px;\n  padding: 8px 10px;\n  font-size: 13px;\n  color: #5d3b00;\n  text-align: left;\n  line-height: 1.5;\n}\n", ""]);
// Exports
module.exports = exports;
